import { Link } from 'react-router-dom';

import { getInfo } from '@Components/Grid/components/Table/formatters';

export default function OrganizationLinkFormatter({ info }) {
  const { row } = getInfo(info)
  const { id, name } = row.organization || {}

  return <Link to={`organizations/${id}`} className="twy-text-base-accent hover:underline" >
    {`[#${id}] - ${name}`}
  </Link>
}
